import { atom } from 'jotai';
import type { LatLng } from '@/core/utils';
import { DEFAULT_SETTINGS_INPUT, type SettingsInput } from '../model/settings';
import type { ConeResult, GlideMode } from '../model/types';

// Read these freely; change them through the action atoms in ./actions.ts.

export const modeAtom = atom<GlideMode>('fly');

export const settingsInputAtom = atom<SettingsInput>(DEFAULT_SETTINGS_INPUT);

/** The clicked point and the role it was clicked in. */
export const originAtom = atom<(LatLng & { mode: GlideMode }) | null>(null);

/** Last completed computation; kept while a new one runs. */
export const resultAtom = atom<ConeResult | null>(null);

export type ComputeStatus =
  | { kind: 'idle' }
  | { kind: 'loading' }
  | { kind: 'searching'; size: number }
  | { kind: 'done' }
  | { kind: 'error'; error: unknown };

export const statusAtom = atom<ComputeStatus>({ kind: 'idle' });

export interface Inspection {
  /** Result cell nearest to `at` (its flight path is drawn). */
  cell: number;
  /** The exact point inspected. */
  at: LatLng;
  /** Tapped on a touch screen and kept until dismissed, rather than following the mouse. */
  pinned: boolean;
}

/** Point of the result whose details and flight path are shown. */
export const inspectionAtom = atom<Inspection | null>(null);
